export default "__VITE_ASSET__O9qXeWLy__"